var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "currentColor",
    fillRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.711,346.037l3.384-3.385a0.828,0.828,0,0,1,1.17,0l1.68,1.68,3.385-3.385-1.68-1.68a0.829,0.829,0,0,1,0-1.171l3.385-3.385a0.826,0.826,0,0,1,1.17,0l2.261,2.261c1.034,1.034,1.277,2.676.686,4.622a13.1,13.1,0,0,1-3.325,5.235c-2.245,2.245-5,3.64-7.184,3.64a3.671,3.671,0,0,1-2.67-1l-2.262-2.262A0.827,0.827,0,0,1,21.711,346.037Zm3.432,2.261a2.042,2.042,0,0,0,1.5.516c1.737,0,4.1-1.239,6.014-3.155a11.446,11.446,0,0,0,2.912-4.546c0.4-1.315.3-2.4-.273-2.97l-1.676-1.677L31.4,338.682l1.68,1.679a0.828,0.828,0,0,1,0,1.171l-4.555,4.555a0.826,0.826,0,0,1-1.17,0l-1.68-1.679-2.213,2.214Z",
    transform: "translate(-21.469 -334.469)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.1814a93e.svg";
export { ForwardRef as ReactComponent };